const RECAPTCHA_CONFIG = window.CONVERSSO_RECAPTCHA || { enabled: false, siteKey: "" };
const RECAPTCHA_EXECUTION_TIMEOUT_MS = 12000;

const RECAPTCHA_ACTION_BY_FORM_SOURCE = {
    landing_demo: "landing_submit",
    website_request_demo: "request_demo_submit",
    website_contact_sales: "contact_sales_submit",
};

function isRecaptchaEnabled() {
    return Boolean(RECAPTCHA_CONFIG.enabled && RECAPTCHA_CONFIG.siteKey);
}

function getRecaptchaMessages(form) {
    const data = form ? form.dataset : {};
    return {
        processing: data.recaptchaMsgProcessing || "",
        unavailable: data.recaptchaMsgUnavailable || "",
        invalidKey: data.recaptchaMsgInvalidKey || "",
        timeout: data.recaptchaMsgTimeout || "",
        genericError: data.recaptchaMsgGenericError || "",
    };
}

function getExpectedAction(form) {
    const sourceInput = form.querySelector("input[name='form_source']");
    const source = (sourceInput ? sourceInput.value : "").trim().toLowerCase();
    return RECAPTCHA_ACTION_BY_FORM_SOURCE[source] || "landing_submit";
}

function ensureRecaptchaTokenInput(form) {
    let tokenInput = form.querySelector("input[name='g-recaptcha-response']");
    if (!tokenInput) {
        tokenInput = document.createElement("input");
        tokenInput.type = "hidden";
        tokenInput.name = "g-recaptcha-response";
        form.appendChild(tokenInput);
    }

    return tokenInput;
}

function getInlineErrorElement(form) {
    let messageElement = form.querySelector("[data-recaptcha-inline-status='true']");
    if (!messageElement) {
        messageElement = document.createElement("p");
        messageElement.dataset.recaptchaInlineStatus = "true";

        if (form.classList.contains("hero__form")) {
            messageElement.className = "hero__form-status hero__form-status--error";
            messageElement.dataset.status = "captcha_invalid";
        } else if (form.classList.contains("website-request-demo__form")) {
            messageElement.className = "website-request-demo__status website-request-demo__status--error";
        } else {
            messageElement.className = "website-contact-sales__status website-contact-sales__status--error";
        }

        const submitButton = form.querySelector("button[type='submit'], input[type='submit']");
        if (submitButton && submitButton.parentElement === form) {
            form.insertBefore(messageElement, submitButton);
        } else {
            form.appendChild(messageElement);
        }
    }

    return messageElement;
}

function getSubmitButton(form) {
    return form.querySelector("button[type='submit'], input[type='submit']");
}

function setSubmitState(form, isProcessing, messages) {
    const submitButton = getSubmitButton(form);
    if (!submitButton) return;

    if (isProcessing) {
        submitButton.disabled = true;
        submitButton.dataset.recaptchaOriginalLabel = submitButton.tagName === "INPUT" ? submitButton.value : submitButton.textContent || "";

        if (submitButton.tagName === "INPUT") {
            submitButton.value = messages.processing;
        } else {
            submitButton.textContent = messages.processing;
        }
        return;
    }

    submitButton.disabled = false;
    const original = submitButton.dataset.recaptchaOriginalLabel;
    if (typeof original === "string" && original.length > 0) {
        if (submitButton.tagName === "INPUT") {
            submitButton.value = original;
        } else {
            submitButton.textContent = original;
        }
    }
}

function clearInlineError(form) {
    const messageElement = form.querySelector("[data-recaptcha-inline-status='true']");
    if (messageElement) {
        messageElement.remove();
    }
}

function showInlineError(form, message) {
    const messageElement = getInlineErrorElement(form);
    messageElement.textContent = message || "";
}

function resolveErrorMessage(error, messages) {
    const raw = String(error?.message || "").toLowerCase();
    if (raw.includes("invalid site key")) {
        return messages.invalidKey;
    }
    if (raw.includes("grecaptcha_not_available")) {
        return messages.unavailable;
    }
    if (raw.includes("recaptcha_timeout")) {
        return messages.timeout;
    }
    return messages.genericError;
}

function executeRecaptcha(action) {
    return new Promise((resolve, reject) => {
        let settled = false;

        const settleResolve = (token) => {
            if (settled) return;
            settled = true;
            clearTimeout(timeoutId);
            resolve(token);
        };

        const settleReject = (error) => {
            if (settled) return;
            settled = true;
            clearTimeout(timeoutId);
            reject(error);
        };

        const timeoutId = window.setTimeout(() => {
            settleReject(new Error("recaptcha_timeout"));
        }, RECAPTCHA_EXECUTION_TIMEOUT_MS);

        if (!window.grecaptcha || typeof window.grecaptcha.ready !== "function" || typeof window.grecaptcha.execute !== "function") {
            settleReject(new Error("grecaptcha_not_available"));
            return;
        }

        window.grecaptcha.ready(() => {
            try {
                Promise.resolve(window.grecaptcha.execute(RECAPTCHA_CONFIG.siteKey, { action }))
                    .then((token) => settleResolve(token))
                    .catch((error) => settleReject(error));
            } catch (error) {
                settleReject(error);
            }
        });
    });
}

async function onProtectedFormSubmit(event) {
    if (!isRecaptchaEnabled()) return;

    const form = event.currentTarget;
    if (form.dataset.recaptchaSubmitting === "true") return;

    event.preventDefault();
    const messages = getRecaptchaMessages(form);
    clearInlineError(form);
    setSubmitState(form, true, messages);

    try {
        const action = getExpectedAction(form);
        const token = await executeRecaptcha(action);
        if (!token) {
            throw new Error("empty_recaptcha_token");
        }

        const tokenInput = ensureRecaptchaTokenInput(form);
        tokenInput.value = token;

        form.dataset.recaptchaSubmitting = "true";
        form.submit();
    } catch (error) {
        showInlineError(form, resolveErrorMessage(error, messages));
        setSubmitState(form, false, messages);
    }
}

function initRecaptchaV3Forms() {
    const forms = document.querySelectorAll(".hero__form, .website-request-demo__form, .website-contact-sales__form");
    forms.forEach((form) => {
        form.addEventListener("submit", onProtectedFormSubmit);
    });
}

if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initRecaptchaV3Forms);
} else {
    initRecaptchaV3Forms();
}
